import { CatalogMenu } from './CatalogMenu';

let wwzrdsCatalogMenu;

document.addEventListener('DOMContentLoaded', () => {
	const catalogMenuElement = document.querySelector('.catalog-menu');
	if (catalogMenuElement) {
		// Ensure element has an id for aria-controls
		if (!catalogMenuElement.id) {
			catalogMenuElement.id = 'catalog-menu';
		}
		wwzrdsCatalogMenu = new CatalogMenu(catalogMenuElement);
	}
});

export { wwzrdsCatalogMenu };


